// extracted by mini-css-extract-plugin
export default {"box":"Box_box__qAT-2","number":"Box_number__Fs0Hw","text":"Box_text__8aHRT"};